/**
 * @generated SignedSource<<50d5c66bf26a84cd6527e6064d18c5ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCompanyInfo_company$data = {
  readonly location: {
    readonly lat: number | null;
    readonly lng: number | null;
  } | null;
  readonly logoUrl: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"Countdown_company">;
  readonly " $fragmentType": "useCompanyInfo_company";
};
export type useCompanyInfo_company$key = {
  readonly " $data"?: useCompanyInfo_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCompanyInfo_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCompanyInfo_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "location",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lng",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Countdown_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "e6276ce28628da15687fac31842c5d38";

export default node;
